/* eslint-disable no-magic-numbers -- surface tokens are named by number */

import styled from 'styled-components';
import { Icon } from '../icon';

export const Wrapper = styled.div`
	width: 100%;
	border-radius: 4px;
	background-color: ${({ theme }) => theme.surface[3]};
	// Inset highlight instead of a stroke, like the other cards on the surface.
	box-shadow: ${({ theme }) => theme.shadow.inset};
	font-family: "Red Hat Display", sans-serif;
`;

export const Header = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 16px 20px;
	cursor: pointer;
	background-color: transparent;
	transition: background-color 0.2s ease;
	border: 1px solid transparent;

	&:focus-visible {
		border: 1px solid ${({ theme }) => theme.border.active};
		border-radius: 4px;
		z-index: 50;
	}

	&:focus:not(:focus-visible) {
		border: 1px solid transparent;
	}
`;

export const HeaderLeft = styled.div`
	display: flex;
	align-items: center;
	gap: 14px;
	flex: 1;
	min-width: 0;
`;

export const PlusIcon = styled(Icon)`
	border-radius: 50%;
	background-color: ${({ theme }) => theme.fill.brand};
	width: 32px;
	height: 32px;
	padding-left: 1px;
	color: ${({ theme }) => theme.text.inverted};
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 13px;
	flex-shrink: 0;
`;

export const TitleBlock = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2px;
	min-width: 0;
`;

export const Title = styled.h3`
	margin: 0;
	font-weight: 400;
	color: ${({ theme }) => theme.text.primary};
	font-size: 14px;
	line-height: 140%;
`;

export const Subtitle = styled.span`
	margin: 0;
	font-weight: 400;
	color: ${({ theme }) => theme.text.tertiary};
	font-size: 12px;
	line-height: 120%;
`;

export const HeaderRight = styled.div`
	display: flex;
	align-items: center;
	gap: 12px;
`;

export const FormFieldWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 6px;

	& + & {
		margin-top: 16px;
	}
`;

export const LabelRow = styled.div`
	display: flex;
	align-items: center;
	gap: 4px;
`;

export const TooltipTrigger = styled.span`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 16px;
	height: 16px;
	cursor: help;
`;
